import { Injectable } from '@angular/core';
import { Router, Event as NavigationEvent, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BodyBackgroundService {
  html: HTMLElement = document.getElementsByTagName('html')[0];
  body: HTMLElement = document.getElementsByTagName('body')[0];

  constructor(private readonly router: Router) {}

  subscribeToRouteEvents(): void {
    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        const route = this.router.routerState.snapshot.root;
        this.checkRouteForBackground(route);
      }
    });
  }

  private checkRouteForBackground(route: any): void {
    if (route) {
      // Check current route data
      if (route.data?.background) {
        this.setBackground(route.data.background);
        return;
      }

      // Check child routes if no background found
      if (route.firstChild) {
        this.checkRouteForBackground(route.firstChild);
      } else {
        this.removeBackground();
      }
    }
  }

  setBackground(backgroundUrl?: string): void {
    const background = backgroundUrl || 'assets/splash_bck.jpg';
    this.html.style.setProperty('--ion-background-color', `url("${background}") no-repeat center/cover fixed`);
    this.html.style.setProperty('--ion-toolbar-background', 'transparent');
    this.body.classList.add('background');
  }

  removeBackground(): void {
    this.html.style.setProperty('--ion-background-color', '#FFFEF9');
    this.html.style.setProperty('--ion-toolbar-background', '#FFFEF9');
    this.body.classList.remove('background');
  }
}
